import NumberComponents from './Number.vue';

const digit = {
    install:function(Vue) {
        Vue.component('digit', NumberComponents)
    }
}

export default digit;